import { useAuth0 } from "@auth0/auth0-react";
import { useSelector } from "react-redux";
import { isStaffEmail } from "@utils/user_utils";

/**
 * Whether this user may use DataViz AI. Same rule as ChatbotV2/ChatView, so the
 * AI Insights widget is available exactly when the chat page is: the palette
 * card locks and the tile renders a no-access state with no network call.
 */
export function useAiAccess(): boolean {
  const { user } = useAuth0();
  const dvaiEnabled = useSelector(({ team }: any) => team?.info?.dvai_enabled);
  return !!dvaiEnabled || isStaffEmail(user?.email);
}
